import { apiClient } from '@copro/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { keys } from './keys';

type Command = {
  groupId: string;
  /** Column ids in their new order. */
  columnIds: string[];
};

async function reorderQuoteColumns(command: Command) {
  const results = await Promise.all(command.columnIds.map((columnId, order) => (
    apiClient.from('quote_comparison_columns').update({ order }).eq('id', columnId)
  )));
  const failed = results.find((result) => result.error);

  if (failed?.error) {
    throw failed.error;
  }
}

export function useReorderQuoteColumns() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: reorderQuoteColumns,
    onSettled: (_data, _error, command) => {
      queryClient.invalidateQueries({ queryKey: keys.columns(command.groupId) });
    },
    onError: () => {
      enqueueSnackbar('L\'ordre des critères n\'a pas pu être enregistré. Réessayez.', 'error');
    },
  });
}
